export const regexEmail =
  /^[a-zA-Z0-9!?._-]{2,60}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export const regexPassword = /^[A-Za-z0-9!?_.-]{4,50}$/;

export const regexText = /^[A-ZŽŠĆČĐa-zžšćčđ0-9!?_()[]*.&^%$,\s]{2,1000}$/;

export const regexGreatherThanOne = /^(?:[1-9]|\d{2,})$/;

export const regexGreatherThanZero = /^(?:[0-9]|\d{2,})$/;

export const regexPhoneNumber =
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}|[0-9]{6,11}$/;